import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { Panel } from 'components/index';
import { PageTitle } from 'components/PageTitle';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect, useState } from 'react';
import type { RouteChildrenProps } from 'react-router';
import { Button } from 'shared/io';
import { onBoardingActions } from 'store/onBoarding/onBoarding.actions';
import { INTEGRATIONS_ROUTE, Integration } from '../../Integrations.constants';
import { INTEGRATION_UPDATE_CALLBACK } from '../Integration.constants';
import styleIdentifiers from '../Integration.module.scss';
import { useGetIntegrationRights } from '../Integration.utils';
import { IntegrationHeader } from '../IntegrationHeader';
import { PontoForm, type PontoFormFields } from './PontoForm';

const styles = classNames.bind(styleIdentifiers);

export const Ponto = ({ history: { replace } }: RouteChildrenProps) => {
  const { t } = useTranslation();

  const company = useCompanyConfiguration();

  const [isEditting, setIsEditting] = useState(false);
  const getIntegrationRights = useGetIntegrationRights();

  const { isActive, canActivate } = getIntegrationRights(Integration.PONTO);

  useEffect(() => {
    if (!canActivate && !isActive) {
      replace(INTEGRATIONS_ROUTE);
    }
  }, [canActivate, isActive, replace]);

  if (!company?.tp_accounting) {
    return (
      <div className={styles('loading')}>
        <div>{t(i18nKeys.LOADING)}</div>
      </div>
    );
  }

  const handleSubmit = (data: PontoFormFields) => {
    onBoardingActions.ponto({
      settings: true,
      data,
      callback: () => {
        INTEGRATION_UPDATE_CALLBACK();
        setIsEditting(false);
      },
    });
  };

  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.PONTO}
        <PageTitle.Actions>
          <IntegrationHeader name={Integration.PONTO} />
        </PageTitle.Actions>
      </PageTitle>
      <Stack>
        <Panel>
          {!isEditting && isActive ? (
            <>
              <div className={styles('row')}>
                <div className={styles('attribute')}>{t(i18nKeys.SETTINGS.CLIENT_ID)}:</div>
                <div className={styles('value')}>
                  *****{company.ponto_integration.ponto_client_id}
                </div>
              </div>
              <div className={styles('row')}>
                <div className={styles('attribute')}>
                  {t(i18nKeys.SETTINGS.INTEGRATIONS.PONTO.SECRET_CODE)}:
                </div>
                <div className={styles('value')}>
                  *****{company.ponto_integration.ponto_client_secret}
                </div>
              </div>
              <div className={styles('button-wrapper')}>
                <Button
                  label={t(i18nKeys.EDIT)}
                  onClick={() => setIsEditting(current => !current)}
                />
              </div>
            </>
          ) : (
            <PontoForm onSubmit={handleSubmit} />
          )}
        </Panel>
      </Stack>
    </>
  );
};
